import { useReactiveVar } from '@apollo/client';
import { Button, FieldInput, Meta, theme } from 'aimo-ui';
import { showToast } from 'components/common/CustomToast';
import { Container } from 'components/park/styles/styles';
import HslContext from 'context/HslContext';
import useUpdateCustomerMutation from 'hooks/useUpdateCustomerMutation';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { country } from 'states/persistInStorage';
import { StyledWrapper } from 'styles/ContainerStyles';

const HslMandatoryUpdatePhonenumberScreen: React.FC = () => {
  const [mobilePhone, setMobilePhone] = useState('');
  const countryCode = useReactiveVar(country);
  const { setCurrentScreen } = useContext(HslContext);
  const { t } = useTranslation();
  const callback = () => {
    showToast(t('success.phoneNumberUpdated'), 'success');
    setCurrentScreen('BUY_TICKET');
  };
  const { updateCustomer, loading } = useUpdateCustomerMutation({ callback });

  const handleInternationalNumber = useCallback(() => {
    switch (countryCode) {
      case 'FI':
        return '+358';
      case 'SE':
        return '+46';
      case 'NO':
        return '+47';
      default:
        return '';
    }
  }, [countryCode]);

  useEffect(() => {
    if (mobilePhone === '' || !mobilePhone?.includes('+')) {
      setMobilePhone(handleInternationalNumber());
    }
  }, [mobilePhone, handleInternationalNumber]);

  const isValidPhoneNumber = (phone: string) => {
    switch (countryCode) {
      case 'FI':
        return /^\+358\d{5,12}$/.test(phone);
      case 'SE':
        return /^\+46\d{7,13}$/.test(phone);
      case 'NO':
        return /^\+47\d{8}$/.test(phone);
      default:
        return false;
    }
  };

  const onPress = () => {
    updateCustomer({
      variables: {
        input: {
          mobilePhone,
        },
      },
    });
  };

  return (
    <Container testID="hsl-mandatory-phone-update-container" mr={20} ml={20}>
      <StyledWrapper center mb={30}>
        <Meta color={theme.colors.gray300}>
          {t('hslTicket.updatePhoneInfo')}
        </Meta>
      </StyledWrapper>
      <StyledWrapper mb={30}>
        <FieldInput
          title={t('account.mobilePhone')}
          value={mobilePhone}
          keyboardType="phone-pad"
          onChangeText={setMobilePhone}
          testID="hsl-update-phone-number-field"
        />
      </StyledWrapper>
      <Button
        size="l"
        testID="hsl-update-phone-number-button"
        text={t('button.save')}
        buttonType="secondary"
        loading={loading}
        disabled={!isValidPhoneNumber(mobilePhone) || loading}
        onPress={onPress}
      />
    </Container>
  );
};

export default HslMandatoryUpdatePhonenumberScreen;
